export function formatCitation(raw: string): string {
  if (!raw) return '';
  const trimmed = raw.trim();

  // Handle s.X or sec.X
  if (trimmed.startsWith('s.') || trimmed.startsWith('sec.')) {
    const numPart = trimmed.replace(/^(s\.|sec\.)\s*/i, '');
    return `Section ${numPart}`;
  }

  // Handle r.X or rule.X
  if (trimmed.startsWith('r.') || trimmed.startsWith('rule.')) {
    const numPart = trimmed.replace(/^(r\.|rule\.)\s*/i, '');
    return `Rule ${numPart}`;
  }

  // Handle schedule
  if (trimmed.toLowerCase().includes('schedule')) {
    return trimmed;
  }

  return trimmed;
}

export function getTrancheInfo(commencementDate: string) {
  if (commencementDate === '2025-11-13') {
    return {
      tranche: 'Tranche 1',
      date: '13 Nov 2025',
      status: 'In Force',
      badgeClass: 'bg-emerald-500/15 text-emerald-700 dark:text-emerald-400 border-emerald-500/30',
      description: 'DPB Establishment & Inquiry Powers'
    };
  } else if (commencementDate === '2026-11-13') {
    return {
      tranche: 'Tranche 2',
      date: '13 Nov 2026',
      status: 'Consent Managers',
      badgeClass: 'bg-sky-500/15 text-sky-700 dark:text-sky-400 border-sky-500/30',
      description: 'Consent Manager Framework & Subordinate Rules'
    };
  } else {
    return {
      tranche: 'Tranche 3',
      date: '13 May 2027',
      status: 'Core Enterprise Duties',
      badgeClass: 'bg-amber-500/15 text-amber-700 dark:text-amber-400 border-amber-500/30',
      description: 'General Enterprise Obligations, Rights & Enforcement'
    };
  }
}
